import React, { useEffect, useState } from 'react';
import IntegerInput from './IntegerInput';
import { parseAdet } from '../utils/integerInput';
import './SiparisParcaAdetModal.css';

/**
 * TP Sipariş Oluştur — seçilen parça satırında adet düzenleme (anında ana modala yansır).
 */
const SiparisParcaAdetModal = ({ open, parca, onAdetChange, onClose }) => {
  const icerikId = parca ? parca.icerikId || parca.id : null;
  const [draftAdet, setDraftAdet] = useState('1');

  useEffect(() => {
    if (open && parca) {
      setDraftAdet(String(parca.adet || 1));
    }
  }, [open, parca?.icerikId, parca?.id]);

  if (!open || !parca || !icerikId) return null;

  const digitsOnly = (raw) => String(raw ?? '').replace(/\D/g, '');

  const resolveDraftToAdet = (raw) => {
    const digits = digitsOnly(raw);
    return digits === '' ? 1 : parseAdet(digits, { min: 1 });
  };

  const commitAdet = (num) => {
    const n = Math.max(1, num);
    setDraftAdet(String(n));
    onAdetChange?.(icerikId, n);
  };

  const handleDraftChange = (nextRaw) => {
    const digits = digitsOnly(nextRaw);
    setDraftAdet(digits);
    if (digits !== '') {
      onAdetChange?.(icerikId, parseAdet(digits, { min: 1 }));
    }
  };

  const handleDraftBlur = () => {
    commitAdet(resolveDraftToAdet(draftAdet));
  };

  const bump = (delta) => {
    commitAdet(resolveDraftToAdet(draftAdet) + delta);
  };

  const currentAdet = resolveDraftToAdet(draftAdet);

  return (
    <div
      className="siparis-parca-adet-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Parça adedi"
      onClick={onClose}
    >
      <div
        className="siparis-parca-adet-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="modal-close-btn siparis-parca-adet-dialog__close"
          onClick={onClose}
          aria-label="Kapat"
        >
          <i className="fas fa-times" />
        </button>

        <div className="siparis-parca-adet-dialog__meta">
          <h3 className="siparis-parca-adet-dialog__title">{parca.parcaAdi || '—'}</h3>
          <p className="siparis-parca-adet-dialog__code">
            <span className="siparis-parca-adet-dialog__code-label">Parça kodu</span>
            <span>{parca.parcaKodu || '—'}</span>
          </p>
        </div>

        <div className="siparis-parca-adet-dialog__qty-block">
          <label className="siparis-parca-adet-dialog__qty-label" htmlFor="siparis-parca-adet-input">
            Adet
          </label>
          <div className="siparis-parca-adet-dialog__qty-row">
            <IntegerInput
              id="siparis-parca-adet-input"
              min={1}
              allowEmpty
              className="siparis-parca-adet-dialog__qty-input"
              value={draftAdet}
              onChange={handleDraftChange}
              onBlur={handleDraftBlur}
              aria-label="Adet"
            />
            <div className="siparis-parca-adet-dialog__qty-steppers">
              <button
                type="button"
                className="siparis-parca-adet-dialog__step-btn"
                onClick={() => bump(1)}
                aria-label="Adedi artır"
              >
                <i className="fas fa-plus" aria-hidden />
              </button>
              <button
                type="button"
                className="siparis-parca-adet-dialog__step-btn"
                onClick={() => bump(-1)}
                disabled={currentAdet <= 1}
                aria-label="Adedi azalt"
              >
                <i className="fas fa-minus" aria-hidden />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiparisParcaAdetModal;
